export const MIX_PANEL_PROJECT_ID = process.env["REACT_APP_MIX_PANEL_PROJECT_ID"] || "no mixpanel project id";